var _rect, _g, _path, _path2, _g2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgOccupationalDisabilityInsurance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 106,
    viewBox: "0 0 112 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 106,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_40_2721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-39 -16C-39 -22.6274 -33.6274 -28 -27 -28H139C145.627 -28 151 -22.6274 151 -16V159.231C151 165.858 145.627 171.231 139 171.231H-27C-33.6274 171.231 -39 165.858 -39 159.231V-16Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.375 53.5C111.375 82.4949 87.8699 106 58.875 106C29.8801 106 6.375 82.4949 6.375 53.5C6.375 24.5051 29.8801 1 58.875 1C87.8699 1 111.375 24.5051 111.375 53.5Z",
    fill: "#D6E8F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_40_2721",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 1,
    width: 106,
    height: 105
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.375 53.5C111.375 82.4949 87.8699 106 58.875 106C29.8801 106 6.375 82.4949 6.375 53.5C6.375 24.5051 29.8801 1 58.875 1C87.8699 1 111.375 24.5051 111.375 53.5Z",
    fill: "#D6E8F6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_40_2721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.2262 57.96V72.2188H29.0303V57.96C29.0303 48.8906 33.3184 40.5005 39.9909 34.867L58.9686 45.2948L59.1282 45.215L78.2656 34.867C84.9381 40.5005 89.2262 48.8906 89.2262 57.96Z",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2269 57.96C89.2269 62.6212 89.2269 67.2824 89.2269 71.9436H59.1289V45.215L78.2663 34.867C84.9387 40.5005 89.2269 48.8906 89.2269 57.96Z",
    fill: "#4B81AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2264 71.7365H29.0305L26 73.7667V75.1814C26 75.1814 36.7785 82 59.1285 82C81.4785 82 92.257 75.1814 92.257 75.1814V73.8377L89.2264 71.7365Z",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2269 71.7365H59.1289V82C81.4789 82 92.2574 75.1814 92.2574 75.1814V73.8377L89.2269 71.7365Z",
    fill: "#4B81AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.257 73.6661C92.257 71.7636 90.7147 70.2213 88.8121 70.2213H29.4448C27.5423 70.2213 26 71.7636 26 73.6661C26 73.6661 46.2488 75.939 59.1285 75.939C72.0082 75.939 92.257 73.6661 92.257 73.6661Z",
    fill: "#4B81AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2574 73.6661C92.2574 71.7636 90.7151 70.2213 88.8126 70.2213H59.1289V75.939C72.0086 75.939 92.2574 73.6661 92.2574 73.6661Z",
    fill: "#2F6086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.319 29.1141C67.1593 29.0741 63.164 29.0741 59.1286 29.0741C55.0932 29.0741 51.0579 29.0741 50.9382 29.1141C46.903 30.2726 43.1474 32.2702 39.9912 34.8671L44.346 47.8518C45.145 50.3289 47.4223 51.9671 50.0192 51.9671H68.238C70.8348 51.9671 73.1122 50.3289 73.9112 47.8518L78.266 34.8671C75.1498 32.3503 71.3143 30.2326 67.319 29.1141Z",
    fill: "#4B81AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2383 51.9671H59.1289V29.0741C63.1642 29.0741 67.1595 29.0741 67.3193 29.1141C71.3146 30.2326 75.1502 32.3503 78.2664 34.8671L73.9115 47.8518C73.1125 50.3289 70.8352 51.9671 68.2383 51.9671Z",
    fill: "#2F6086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8002 25.7979C63.7626 24.5993 61.4454 24 59.1282 24C56.8109 24 54.4937 24.5994 52.4561 25.7979C50.2985 27.0764 49.1399 29.5934 49.6594 32.1106L53.4949 51.9671H64.7614L68.597 32.1106C69.1164 29.5936 67.9579 27.0765 65.8002 25.7979Z",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7622 51.9671H59.1289V24C61.4463 24 63.7633 24.5994 65.8009 25.7979C67.9585 27.0764 69.1172 29.5934 68.5977 32.1106L64.7622 51.9671Z",
    fill: "#4B81AC"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.27543C0 5.93148 0.291786 5.64485 0.664196 5.6341C0.779375 5.63051 11.8634 5.25789 18.3595 0.163032C18.6282 -0.0519407 19.0237 -0.0555235 19.2924 0.15945L19.2963 0.163032C25.7923 5.26148 36.8495 5.6341 36.9608 5.63768C37.3294 5.64843 37.625 5.93148 37.625 6.27902V6.32918C37.625 15.1861 36.0739 27.5685 28.4261 36.2427C23.7959 41.4952 19.2079 42.8782 19.0121 42.9355L18.8048 43L18.5898 42.9355C18.394 42.8782 13.8329 41.4952 9.20277 36.2427C1.55107 27.5649 0 15.1861 0 6.32559V6.27543Z",
    fill: "#3A8761"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5735 21.0833L16.7399 25.0842C17.1272 25.4561 17.739 25.4557 18.1259 25.0834L27.1772 16.373C27.8312 15.7436 27.8312 14.6969 27.1772 14.0675C26.5578 13.4714 25.578 13.4714 24.9586 14.0675L17.43 21.3126L14.7896 18.776C14.1695 18.1803 13.1894 18.1814 12.5706 18.7786C11.9178 19.4086 11.9191 20.4549 12.5735 21.0833Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_40_2721",
    x: -59,
    y: -44,
    width: 230,
    height: 239.231,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.239216 0 0 0 0 0.270588 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_40_2721"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_40_2721",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgOccupationalDisabilityInsurance);
export default __webpack_public_path__ + "static/media/imgOccupationalDisabilityInsurance.c7d5e5e0ba63961e50d50fbc7e0d8b2b.svg";
export { ForwardRef as ReactComponent };